import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import type { StreamThemeMode } from '@stream-io/video-react-sdk';
export type ThemeMode = StreamThemeMode;
const THEME_MODE_KEY = '@pronto/theme-mode';
const DEFAULT_THEME_MODE: ThemeMode = 'dark';
const getStoredThemeMode = (): ThemeMode => {
  if (typeof window === 'undefined') return DEFAULT_THEME_MODE;
  try {
    const stored = window.localStorage.getItem(THEME_MODE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : DEFAULT_THEME_MODE;
  } catch {
    return DEFAULT_THEME_MODE;
  }
};
export const useThemeMode = () => {
  const $ = _c(5);
  const [themeMode, _setThemeMode] = useState(DEFAULT_THEME_MODE);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      _setThemeMode(getStoredThemeMode());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      _setThemeMode(value);
      ;
      try {
        window.localStorage.setItem(THEME_MODE_KEY, value);
      } catch (t3) {
        const e = t3;
        console.warn("Theme mode couldn't be stored", e);
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setThemeMode = t2;
  let t3;
  if ($[3] !== themeMode) {
    t3 = {
      themeMode,
      setThemeMode
    };
    $[3] = themeMode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const chatThemeClass = (mode: ThemeMode) => mode === 'dark' ? 'str-chat__theme-dark' : 'str-chat__theme-light';